// ======================================================================
// File Name       : ContentDrillSkinList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead, { setSortState } from '../TableHead';
import { CONTENT, CONTENT_DRILL_SKIN } from '../../constants/PathConstants';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { getItemBoxName } from '../../utils/index';
import { CONVERT_STATUS } from '../../constants/ContentConstant';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import CustomButton from '../button/CustomButton';

const ContentDrillSkinList = ({ skinList, handleSortState, handleDownloadSkinFile, searchInfo, handleMouseEnter, handleMouseLeave, hoverIndex }) => {
  const thead = [
    { title: 'スキン識別ID', sortBy: 0},
    { title: 'スキン名', sortBy: 1 },
    { title: '変換ステータス', sortBy: 2},
    { title: '操作', sortBy: null},
    { title: 'ダウンロード', sortBy: null},
  ];
  let data = thead;
  if (searchInfo) {
    const sortBy = searchInfo.skinSortType;
    const sortState = searchInfo.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  // table data
  let skinTableData = null;
  const onClickDownload = (event) => {
    const { id } = event.target;
    handleDownloadSkinFile(id);
  };
  if (skinList) {
    skinTableData = skinList.map((skin, index) => {
      const skinSetSecernId = skin && skin.skinSetSecernId;
      const linkDetail = `/${CONTENT}/${CONTENT_DRILL_SKIN}/${skinSetSecernId}`;
      const linkFile = `/${CONTENT}/${CONTENT_DRILL_SKIN}/${skin.skinSetFileName}`;
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave}>
          <td>{skinSetSecernId}</td>
          <td>{skin.skinSetName}</td>
          <td>{getItemBoxName(SELECT_BOX_DATA.DRILL_STATUS, skin.convertStatus)}</td>
          <td className="text-center">
            {skinSetSecernId ?
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={linkDetail}
                text="詳細"
              />
              : null

            }
          </td>
          <td className="text-center padding-clear">
            {skinSetSecernId !== '1' &&
              skin.convertStatus === CONVERT_STATUS.CONVERSION_SUCCESS &&
              <CustomButton
                btnStyle="btn-download"
                handleClick={onClickDownload}
                id={skin.skinSetSecernId}
                text="ダウンロード"
              />
            }
          </td>
        </tr>
      );
    });
  }

  return (
    <Table striped hover>
      <thead>
        <TableHead data={data} handleSortState={handleSortState.bind(this)} />
      </thead>
      <tbody>
        {skinTableData}
      </tbody>
    </Table>
  );
};

export default ContentDrillSkinList;
